import { defineStore } from "pinia";
import { instance } from "../index";

import { useLearningObjectiveStore } from "./learning-objective";
import {
  getItemLocalStorage,
  removeItemLocalStorage,
  setItemLocalStorage,
} from "@/utils/save-storage.util";
interface Course {
  courseId: string;
  name: string;
  hasStarted: boolean;
  currentObjective: string;
  courseName: string;
  learningObjectiveStatus: boolean;
  done: boolean;
  pastObjectiveId: string;
  hasCertificate: boolean;
}
export const store = defineStore({
  id: "adapt-course",
  state: () => ({
    course: {} as Course,
    hasCertificate:false
  }),
  actions: {
    setCourse(course: Course) {
      this.course = course;
      const learningObjectiveStore = useLearningObjectiveStore;

      learningObjectiveStore?.setLearningObjective({
        id: course.currentObjective,
        course: course.courseName,
        status: course.learningObjectiveStatus,
        done: course.done,
      });
    },
    setCourseInitiated() {
      setItemLocalStorage(
        "first-time-course" + this.course?.courseId,
        JSON.stringify(false)
      );
      this.course.hasStarted = true;
    },
  },
  getters: {
    hasSpeechRecognition(): boolean {
      return "webkitSpeechRecognition" in window;
    },
    firstTime(state) :boolean{
      return getItemLocalStorage("first-time-course" + this.course?.courseId)
        ? JSON.parse(
            getItemLocalStorage("first-time-course" + this.course?.courseId)
          )
        : !state.course.hasStarted;
    },
  },
});

export const useAdaptCourseStore = store(instance);
